// extracted by mini-css-extract-plugin
export default {"toolbar":"style_toolbar__xVvJd","logo":"style_logo__61IHR","logoffset":"style_logoffset__e-GMo","label":"style_label__Oe3nX"};